import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'howItWorks.title',
		'defaultMessage': 'How to Stog',
	},
	titleIcon1: {
		'id': 'howItWorks.icon1.title',
		'defaultMessage': 'Get a FreshMint',
	},
	labelIcon1: {
		'id': 'howItWorks.icon1.label',
		'defaultMessage': 'Buy or rent some at multiple spots around the world or at our website',
	},
	titleIcon2: {
		'id': 'howItWorks.icon2.title',
		'defaultMessage': 'Do the setup',
	},
	labelIcon2: {
		'id': 'howItWorks.icon2.label',
		'defaultMessage': 'Plug in for power and water. Fill the fertilizer tanks. Merge several boxes if you have them. The setup takes ten minutes per box',
	},
	titleIcon3: {
		'id': 'howItWorks.icon3.title',
		'defaultMessage': 'Get the app',
	},
	labelIcon3: {
		'id': 'howItWorks.icon3.label',
		'defaultMessage': 'Choose a recipe from your smartphone. Besides the sophisticated automation there are also options for manual control',
	},
	titleIcon6: {
		'id': 'howItWorks.icon6.title',
		'defaultMessage': 'Enjoy farming smart',
	},
	labelIcon6: {
		'id': 'howItWorks.icon6.label',
		'defaultMessage': 'Maintenance is mostly automated. The rest is gamified so it would be as fun as possible. Also there is an active community to hang out within the same app',
	},
});


// WEBPACK FOOTER //
// ./src/components/LandingHowItWorks/messages.js